import React from 'react'

const EmployeeGoals = () => {
  return (
    <div>EmployeeGoals</div>
  )
}

export default EmployeeGoals